"use client";

import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/shared/ui/components/button";
import { setCheckoutLocaleCookie } from "@/services/cookie";

export interface LanguageSwitcherButtonProps {
  onSwitch?: (targetLang: string) => void;
  className?: string;
  disabled?: boolean;
}

/** EN/AR language switcher (cookie, URL, i18n). For flows without AppWrapper header. */
export function LanguageSwitcherButton({
  onSwitch,
  className = "",
  disabled = false,
}: LanguageSwitcherButtonProps) {
  const { i18n } = useTranslation();

  const isArabic = i18n.language.startsWith("ar");
  const langLabel = isArabic ? "English" : "العربية";

  const handleClick = useCallback(async () => {
    const targetLang = isArabic ? "en_US" : "ar_SA";

    setCheckoutLocaleCookie(targetLang);

    const url = new URL(window.location.href);
    url.searchParams.set("locale", targetLang);
    window.history.replaceState(
      {},
      "",
      `${url.pathname}?${url.searchParams.toString()}${url.hash}`,
    );

    await i18n.changeLanguage(targetLang);
    onSwitch?.(targetLang);
  }, [isArabic, i18n, onSwitch]);

  return (
    <Button
      variant="plain"
      size="small"
      className={`w-auto px-0 text-center text-sm font-normal leading-[18px] text-[#585B7A] ${className}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {langLabel}
    </Button>
  );
}

export default LanguageSwitcherButton;
